import React from 'react'
import { useIntl } from 'react-intl'
import Image from 'components/Common/Image/Image'
import styled from 'styled-components'
import { rem } from 'polished'

const ImageContainer = styled.div`
  position: relative;
  min-height: ${rem(100)};
  width: 100%;
  aspect-ratio: 3.3 / 1;
  overflow: hidden;
`

function TuroModalImage() {
  const intl = useIntl()

  return (
    <ImageContainer>
      <Image
        image={{ id: 'yatwrvvmzmintrr84gpa' }}
        fit="center"
        objectFit="cover"
        alt={intl.formatMessage({
          id: '1Qf0AjVrT8wX2TJaY6g8',
          defaultMessage: 'Turo promotional image',
          description: 'Alternative text for the Turo partner promotion image in the modal',
        })}
      />
    </ImageContainer>
  )
}

export default TuroModalImage
